module.exports = __webpack_public_path__ + "media/images/oficinas/esquina-42be3cbc0b2ba253f927fc195fd181ad.jpg";